// Delegated to the document rather than bound to individual triggers: the
// product gallery slider re-renders/scrolls its slides independently, and
// this way it doesn't matter how many [data-zoom-src] triggers exist or
// which template rendered them.
(function () {
  const dialog = document.querySelector('[data-product-zoom-dialog]');
  if (!dialog) return;

  const image = dialog.querySelector('[data-product-zoom-image]');
  const closeButton = dialog.querySelector('[data-product-zoom-close]');
  const prevButton = dialog.querySelector('[data-product-zoom-prev]');
  const nextButton = dialog.querySelector('[data-product-zoom-next]');

  let triggers = [];
  let currentIndex = 0;

  function showAt(index) {
    const trigger = triggers[index];
    if (!trigger) return;
    currentIndex = index;
    image.src = trigger.dataset.zoomSrc;
    image.alt = trigger.querySelector('img')?.alt || '';
    const multiple = triggers.length > 1;
    prevButton.hidden = !multiple;
    nextButton.hidden = !multiple;
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-zoom-src]');
    if (!trigger) return;

    // Only this trigger's own gallery, not every [data-zoom-src] on the
    // page (a product page and its "You might also like" recommendations
    // can both have one) - closest common gallery/slider ancestor scopes
    // prev/next to the product actually being viewed.
    const gallery = trigger.closest('product-gallery, .product__images') || document;
    triggers = Array.from(gallery.querySelectorAll('[data-zoom-src]'));
    showAt(triggers.indexOf(trigger));
    dialog.showModal();
  });

  prevButton.addEventListener('click', (event) => {
    event.stopPropagation();
    showAt((currentIndex - 1 + triggers.length) % triggers.length);
  });

  nextButton.addEventListener('click', (event) => {
    event.stopPropagation();
    showAt((currentIndex + 1) % triggers.length);
  });

  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') prevButton.click();
    if (event.key === 'ArrowRight') nextButton.click();
  });

  closeButton.addEventListener('click', () => dialog.close());

  // Only the backdrop closes it now - the image itself used to close on
  // click/tap too, which meant a mobile double-tap-to-zoom gesture (a
  // normal way to zoom in on an image) registered as a tap on the image
  // and closed the whole viewer instead of zooming, on every attempt.
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
})();
